import type { AppLocale } from "@repo/client/format";
import { getLocale } from "@repo/i18n/runtime";

/**
 * The locale the app is rendering in, typed.
 *
 * `getLocale()` answers Paraglide's own union, which is structurally the same
 * as `AppLocale` but is not the type the formatters take. This is the one
 * place the two are tied together.
 *
 * ⚠️ It must stay SYNCHRONOUS. Paraglide's `custom-app` strategy skips a
 * strategy that returns a promise and falls through to en-US (`D164`,
 * `T-165`), so `getLocale()` reads a variable the locale store fills before
 * the first render — and anything that wraps it inherits that constraint.
 *
 * This lived three times, byte for byte, in `features/workout/screens`,
 * `features/wrapped` and `features/progress`, which `pnpm deadcode` reports as
 * a duplicate export: a barrel re-exporting one of them resolves ambiguously,
 * and nothing else in the toolchain sees it.
 */
export function appLocale(): AppLocale {
  return getLocale();
}

/**
 * The exercise catalogue is stored under two-letter codes, not BCP 47 tags —
 * the query parameter the training routes take.
 */
export function catalogueLocale(): "pt" | "en" {
  return appLocale().startsWith("pt") ? "pt" : "en";
}
